import { createBrowserRouter, Navigate } from "react-router-dom";
import { lazyWrap } from "../utils/lazyWrap";
import AuthPagesLayout from "../components/Layouts/AuthPagesLayout";
import ProtectedDashboardLayout from "../components/Layouts/ProtectedDashboardLayout";
import App from "../App";

const router = createBrowserRouter([
  {
    Component: App,
    path: "/",
    children: [
      {
        element: <ProtectedDashboardLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "dashboard",
            lazy: lazyWrap(() => import("../features/dashboard/pages/Dashboard")),
          },
          {
            path: "userProfile",
            lazy: lazyWrap(() => import("../features/profile/pages/Profile")),
          },
          {
            path: "customerManagement",
            lazy: lazyWrap(() => import("../features/management/customer-management/pages/CustomerManagementPage")),
          },
          {
            path: "siteManagement",
            lazy: lazyWrap(() => import("../features/management/site-management/pages/siteManagementPage")),
          },
          {
            path: "contractManagement",
            lazy: lazyWrap(() => import("../features/management/contract-management/pages/ContractManagementPage")),
          },
          {
            path: "locationManagement",
            lazy: lazyWrap(() => import("../features/management/location-management/pages/LocationManagementPage")),
          },
          {
            path: "meterManagement",
            lazy: lazyWrap(() => import("../features/management/meter-management/pages/MeterManagementPage")),
          },
          {
            path: "userManagement",
            lazy: lazyWrap(() => import("../features/management/user-management/pages/UserManagementPage")),
          },
          // Dynamic Route Definitions for Customer, Site, Location, and Meter
          {
            path: "customers/:customerId",
            lazy: lazyWrap(() => import("../features/dashboard/pages/Dashboard")),
            children: [
              {
                path: "sites/:siteId",
                lazy: lazyWrap(() => import("../features/dashboard/pages/Dashboard")),
                children: [
                  {
                    path: "locations/:locationId",
                    lazy: lazyWrap(() => import("../features/dashboard/pages/Dashboard")),
                    children: [
                      {
                        path: "meters/:meterId",
                        lazy: lazyWrap(() => import("../features/dashboard/pages/Dashboard")),
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "auth",
        element: <AuthPagesLayout />,
        children: [
          {
            path: "login",
            lazy: lazyWrap(() => import("../features/auth/pages/Login")),
          },
          {
            path: "verify-2fa",
            lazy: lazyWrap(() => import("../features/auth/pages/Verify2FA")),
          },
          {
            path: "reset-password",
            lazy: lazyWrap(() => import("../features/auth/pages/PasswordRecovery")),
          },
        ],
      },
      {
        path: "*",
        lazy: lazyWrap(() => import("../pages/NoMatchPage")),
      },
    ],
  },
]);

export default router;
